import React, {useEffect} from 'react'
import { isEmpty } from 'lodash'
import classNames from 'classnames'

import { useScrollPosition } from '../../hooks/useScrollPosition'

export default function SerieHeroContainer({ vodTrailer, imagesSite, idUser, useImageCDN, sponsored, serieId }) {
  const scrollPosition = useScrollPosition()

  // Función para dejar fixed header y cambiar opacidad del hero
  function normalizeBetweenTwoRanges(val, minVal, maxVal, newMin, newMax) {
    return newMin + (val - minVal) * (newMax - newMin) / (maxVal - minVal)
  }

  const newOpacity = normalizeBetweenTwoRanges(scrollPosition, 0, 200, 1, 0)

  // Create mdstream player 
  useEffect(() => {
    if (!isEmpty(vodTrailer)) {
      const playerOptions = {
        width: 640,
        height: 360,
        type: 'media',
        id: vodTrailer.idMedia,
        autoplay: true,
        player: process.env.REACT_APP_MDSTRM_ID_PLAYER,
        controls: false,
        show_controls_on_ad: false,
        pause_on_screen_click: false,
        pause_ad_on_click: false,
        customer: idUser,
        volume: 0,
        events: {
          onPlayerReady: function () {
            this.playbackLevel(4)
          },
          onPlay: function () {
            this._playerContainer.classList.add('video-ready')
          },
          onVideoEnd: function() { 
            this.seekTo(0)
            this.videoPlay()
          },
        },
      }
      new window.MediastreamPlayer('video_serieHero', playerOptions)
    }
  }, [idUser, vodTrailer])

  return (
    <div
      className={classNames('heroContentWrap', { 'sponsoredItem sponsoredShowItem': serieId === sponsored._id })}
      style={serieId === sponsored._id ? { backgroundColor: sponsored.bgColor, opacity: newOpacity } : { opacity: newOpacity }}
    >
      <div className='heroImgBox'>
        <span className='shadowLeft'></span>
        <span className='shadowBottom'></span>
        <figure className='ratioImgBox ratioHero'>
          <img
            src={!isEmpty(imagesSite?.hero)
              ? useImageCDN
                ? imagesSite.hero.replace('https://api-megago.megamedia.cl', 'https://megago.cdn.mdstrm.com')
                : imagesSite.hero
              : 'https://images2-mega.cdn.mdstrm.com/ott/placeholders-imgs/placeholder-hero.jpg'
            }
            alt=''
          />
          {
            !isEmpty(vodTrailer) &&
            <div id='video_serieHero' className='ratioVideoChild'></div>
          }
        </figure>
      </div>
      {serieId === sponsored._id && <span className="shadowBottom"></span>}
    </div>
  )
}